export enum PlanStripeLookupKey {
  MONTH = "monthly_plan",
  YEAR = "yearly_plan",
  LIFETIME = "lifetime_plan",
  MONTH_88 = "monthly_plan-0.88",
  YEAR_88 = "yearly_plan-0.88",
}

export enum PlanCode {
  TRIAL = "Trial",
  EXPLORER = "Explorer",
  VISIONARY = "Visionary",
  PRIME = "Prime",
}

